import {Fragment} from 'react';

import {CurrencyService as Service} from './CurrencyService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {useImExExcel} from '../../../shared/hooks/ImExExcel';
import {useTranslation} from '../../../shared/language';

export const List = () => {

  const {t} = useTranslation();
  const header = t('catalog.currency');
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'code', header: t('catalog.currencyCode'), width: 160},
      {field: 'name', header: t('catalog.currencyName'), minWidth: 200},
      {field: 'rate', header: t('common.exchangeRate'), width: 140, dataType: 'number'},
      {field: 'formatQuantity', header: t('catalog.quantityDecimals'), width: 180, dataType: 'number'},
      {field: 'formatPrice', header: t('catalog.unitPriceDecimals'), width: 180, dataType: 'number'},
      {field: 'formatTotal', header: t('catalog.totalDecimals'), width: 180, dataType: 'number'},
      {field: 'formatTaxDetail', header: t('catalog.taxDetailDecimals'), width: 180, dataType: 'number'},
      {field: 'formatTaxAmount', header: t('catalog.taxAmountDecimals'), width: 180, dataType: 'number'},
      {field: 'readCurrency', header: t('catalog.readCurrency'), width: 180},
      {field: 'readDecimal', header: t('catalog.readDecimal'), width: 180}
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'code', header: t('catalog.currencyCode'), required: true, uppercase: true, InputTextProps: {maxLength: 3}, className: 'md:col-4'},
      {field: 'name', header: t('catalog.currencyName'), required: true, InputTextProps: {maxLength: 50}, className: 'md:col-8'},
      {field: 'rate', header: t('common.exchangeRate'), required: true, type: 'InputNumber', InputNumberProps: {min: 0, max: 99999, maxFractionDigits: 2}, className: 'md:col-6'},
      {field: 'formatQuantity', header: t('catalog.quantityDecimals'), required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      {field: 'formatPrice', header: t('catalog.unitPriceDecimals'), required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      {field: 'formatTotal', header: t('catalog.totalDecimals'), required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      {field: 'formatTaxDetail', header: t('catalog.taxDetailDecimals'), required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      {field: 'formatTaxAmount', header: t('catalog.taxAmountDecimals'), required: true, type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6'},
      {field: 'readCurrency', header: t('catalog.readCurrency'), InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'readDecimal', header: t('catalog.readDecimal'), InputTextProps: {maxLength: 500}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderImExExcel, download, showImportDialog} = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-tien-te',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderImExExcel()}
    </Fragment>
  )
}
